<script setup>
  import { onMounted, ref } from "vue";
  import Multiselect from "vue-multiselect";

  const props = defineProps({
    sorts: {
      type: Array,
      default: () => [],
      required: true,
    }
  });

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const emit = defineEmits(["update:sortOrder"]);

  const sortValue = ref( null);

  const sortOptions = ref(props.sorts);
  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + "...";
    } else {
      return str;
    }
  }
  function updateSortOptions(newSorts) {
    console.log(newSorts,sortValue);
    const url = new URL(window.location.href);
    url.pathname = newSorts.link;
    try {
      document.querySelector('#projects-blue-belt h1').textContent = newSorts.label;
    } catch (e) {
      console.log(e);
    }

    url.searchParams.set('page', 1);
    window.history.replaceState(null, "", url.toString());
    emit('update:sortOrder', sortValue)
  }

  /*
  watch(sortValue, (newVal) => {
    if (newVal != null) {
      sortOptions.value.forEach(sort => {
        if (sort.value === newVal.value) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
    }

    emit("update:sortOrder", newVal);
  });*/

  onMounted(() => {
    const url = new URL(window.location.href);

    sortValue.value =
      sortOptions.value
        .map(sort => {
          sort.selected = false;
          if (url.pathname === sort.link) {
            sort.selected = true;
          }
          return sort;
        })
        .filter(sort => sort.selected )[0] || null;

  });

</script>

<template>
  <div class="order-by-series-container">
    <multiselect
      v-model="sortValue"
      :options="sortOptions"
      :searchable="false"
      :allow-empty="true"
      @update:modelValue="updateSortOptions"

      label="label"
      track-by="link"
      placeholder="Type of Project"
      class="meu-multiselect-customizado"
    >

      <template #singleLabel="{ option }">
        <span class="multiselect-label">{{ truncateString(option.label, 15) }}</span>
      </template>
      <template #placeholder>
        <span class="multiselect-label">{{ trans('Type of project') }}</span>
      </template>
    </multiselect>
  </div>
</template>



<style scoped>
  .meu-multiselect-customizado {
    width: auto;
  }

  .meu-multiselect-customizado :deep(.multiselect__content-wrapper) {
    width: max-content;
    min-width: 100%;
    max-width: none;
  }

  .meu-multiselect-customizado :deep(.multiselect__content) {
    width: max-content;
  }

</style>
